
export const  API_URL = 'https://online.mdfc.com.np/api/'
export const IMG_URL = 'https://online.mdfc.com.np/storage/'
